import { Badge } from "@/components/ui/badge";

type Tone = "neutral" | "positive" | "warning" | "critical";

const VARIANT: Record<Tone, "default" | "secondary" | "outline" | "destructive"> = {
  positive: "default",
  neutral: "secondary",
  warning: "outline",
  critical: "destructive",
};

/**
 * Holat nishoni. Rang ma'no tashiydi, lekin YAGONA belgi emas — matn
 * har doim yozilgan. "Yashil nishon" rang ko'rmaydigan moderatorga
 * hech narsa demaydi.
 */
export function StatusBadge({ label, tone = "neutral" }: { label: string; tone?: Tone }) {
  return <Badge variant={VARIANT[tone]}>{label}</Badge>;
}
